import { localget, localset, localremove, sessionremove } from 'Utils/storage'
import api from 'Plugins/api'
import axiosInstance from 'Plugins/axios'
import serviceCtrl from 'Utils/serviceCtrl'
import { getSysType } from 'CommonUtils/plus.js'
import { getClientid } from 'CommonUtils/push'

import { getRelativeDate } from 'Utils/dateUtil'
import NoticeInteractor from '@/business/Domain/use-cases/notice-interactor'
import { Toast } from 'vant'
import privacy from 'Assets/privacy/yxsl'
import { ToPayParams } from '@/business/views/Home/approvalList'
import {getParameter} from 'Utils/publicApi'

export const initialOrderListParams = () => {
  return {
    dateStart: getRelativeDate(-7),
    dateEnd: getRelativeDate(0),
    dateType: '1', // 1 预订日期,2 是出发/入住日期
    findScope: '1', // 1是个人订单,2是全部订单 ,
    findType: '3',// 1全部订单 2待支付 3待出行 4退改 5指定的业务订单（productType必须传值）
    productType: '',//产品类型
    tripType: '',
    psgName: '',//出行人
    orderNo: ''//订单号
  }
}


const app = {
  state: {
    tripType: '1',
    transitionName: 'fade',
    loginConfig: {
      logoUrl: (window.location.host=='m.yixtrip.com')?'https://m.yixtrip.com/ser/staticFile/common/privacy/icon.png':'',
      pageName:(window.location.host=='m.yixtrip.com')?'智通商旅':'',
      compaySuper: '',
      by2: (window.location.host=='m.yixtrip.com')?privacy:'',
      by3:'',
      by4:'',
    },
    userInfo: {},
    serverList: [],
    serviceCtrl: {},//查询页面参数控制
    lastZclx: {}, // 存放上一次ServeiceCtrl的参数，用于因公因私切换时重新实例化 ServiceCtrl
    sysType: getSysType(),//运行环境 10506 h5 10504 安卓 10506 ios
    orderListParams: initialOrderListParams(),
    loginNotices: [],
    badgeDotCount: {
      message: 0,
      messaged: 0,
      approval: 0,
      approvaled: 0,
      topay: 0,
      waitapproval: 0,
      daibantotal: 0
    },
    authorizationPnosMap: [],
    khlx: 1, // 1 企业客户 2 分销  3 散客
    isPush: '',//是否开启推送
    navigationbar:[], //导航栏中的我的、消息、待办是否隐藏
    newpage:false,//是否是新的页面，
    cplx: '',//产品类型详情页面存是否国际
    business:'',//是否隐藏因公因私
    gatconceal:'',//是否关爱通隐藏回头按
  },
  getters: { //getters属性理解为所有组件的computed属性, 也就是计算属性
    serverList: state => state.serverList,
    userInfo: state => {
      if (Object.keys(state.userInfo).length) {
        return state.userInfo
      } else {
        let userInfo = localget('userInfo')
        if(userInfo){
          return userInfo
        }
        return {}
      }
    },
    isPush: () => {
      return localget('isPush')===false?false:true
    }
  },
  mutations: {
    SET_USERINFO: (state, states) => {//用户信息
      state.userInfo = states || {}
      if (state.userInfo.empInfo&&state.userInfo.empInfo.empNo) {
        axiosInstance.defaults.headers['loginUserNo']=encodeURI(state.userInfo.empInfo.empNo)||''
      }
      if (state.userInfo.vipCorp && state.userInfo.vipCorp.khlx) {
        state.khlx = state.userInfo.vipCorp.khlx
      }
    },
    SET_TOKEN: (state, states) => {// 在axios实例已创建后修改token
      // alert('缓存token'+states)
      axiosInstance.defaults.headers['token'] = states
      axiosInstance.defaults.headers['y-cli'] = getSysType()
      localset('access_token', states)
    },
    SET_TRANSITION: (state, states) => {//动画名称
      state.transitionName = states
    },
    SET_LOGINCONFIG: (state, states) => {//登录配置信息
      Object.assign(state.loginConfig, states)
      // if (!state.loginConfig.logoUrl) {
      // 	state.loginConfig.logoUrl = 'https://m.yixtrip.com/ser/staticFile/common/privacy/icon.png'
      // 	// http://sfile.lingduankeji.com/uploadfile/group1/20191223/20/智通logo-156801086706653576-157709409932113148.png
      // }
      if (!state.loginConfig.by2) {
        state.loginConfig.by2 = privacy //默认隐私协议
      }
    },
    SET_TRIPTYPE: (state, states) => {//因公因私
      state.tripType = states
    },
    SET_SERVERLIST: (state, states) => {
      state.serverList = states
    },
    SET_SERVICE (state, states) {//查询页面参数控制
      state.lastZclx = states
      state.serviceCtrl = new serviceCtrl({ ...states, tripType:state.tripType })
    },
    SET_ORDERLISTPARAMS (state, payload) { //订单列表参数
      Object.assign(state.orderListParams, payload)
    },
    // 因公因私切换时重新实例化 ServiceCtrl
    RENEW_SERVICE (state) {
      state.serviceCtrl = new serviceCtrl({ ...state.lastZclx, tripType:state.tripType })
    },
    SET_LOGINNOTICE (state, states) {
      state.loginNotices = states
    },
    SET_BADGEDOTCOUNT (state, states) {
      state.badgeDotCount = states
    },
    SET_AUTHORIZATIONPNOSMAP (state, states) {
      state.authorizationPnosMap = states||[]
    },
    SET_PUSH (state, states) {
      state.isPush = states
      localset('isPush',states)
    },
    SET_NAVBAR(state,states){
      state.navigationbar = states
    },
    newpage(state,states){ //判断新旧页面
      state.newpage = states
    },
    SET_CPLX(state,states){ //列表详情是否国际
      state.cplx = states
    },
    SET_business(state,states){//隐藏因公因私
      state.business = states
    },
    SET_HeaderLeft(state,states){
      console.log("states",states)
      state.gatconceal = states
    },

  },
  actions: {
    async login ({ commit, state, dispatch }, payload) {//登录
      try {
        if (payload.loginName) {
          axiosInstance.defaults.headers['loginUserNo'] = encodeURI(payload.loginName)||''
        }
        payload.openId = localget('openId') || ''
        // alert('app.js 调登录方法 入参'+JSON.stringify(payload))
        const { data = {} } = await api['user/login'](payload)
        if (data.failCount) {
          Toast.fail(data.msg)
          return
        }
        let token = data.token
        // alert('登陆成功返回，得到token'+token)
        commit('SET_TOKEN', token)
        // 获取员工信息
        await dispatch('getUserInfo')

        // 推送 保存  clientid
        if (state.isPush) {
          getClientid()
        }

        // 判断是否首次登陆 强制修改密码
        if (data.ifUpdatePwd == '1') {
          window.location.href = '#/resetPassword'
        } else {
          if (payload.loginType === 2) {
            payload = { loginName: payload.loginName }
          }
          // 记住用户登录参数
          localset('AutoLogin', payload)
          if (!payload.doNotRedirect) {
            window.location.href = '#/home'
          }
        }
      } catch (err) {
        throw err
      }
    },
    //退出登录
    loginOut () {
      return new Promise((resolve, reject) => {
        if (axiosInstance.defaults.headers['token']) {
          api['user/vipLoginOut']().then(() => {
            sessionremove('VUEX_STATE')
            localremove('userInfo')
            localremove('VUEX_STATE')
            var AutoLogin = localget('AutoLogin') || {}
            AutoLogin.password=''
            AutoLogin.loginOut=true
            localset('AutoLogin',AutoLogin)
            localremove('access_token')
            localremove('lastRemember')
            localremove('loginType')
            resolve()
          })
        } else {
          reject()
        }
      })
    },
    //获取用户信息
    async getUserInfo ({ dispatch,commit, state }) {
      try {
        const res = await api['user/getLoginUserInfo']()
        // alert('获取登陆人信息接口'+JSON.stringify(res.data))
        commit('SET_USERINFO', res.data)
        localset('userInfo', res.data || {})
        return res
      } catch (err) {
        throw err
      }
    },
    //获取客服信息
    async getCustomerInfoList ({ commit, state, dispatch }) {
      if (localget('access_token')) {
        await dispatch('getUserInfo')
        try {
          let res = await api['user/getCustomerInfoList']()
          // alert('获取客服接口'+JSON.stringify(res))
          commit('SET_SERVERLIST', res.data || [])
        } catch (err) {
          console.error(err)
          commit('SET_SERVERLIST', [])
        }
      }
    },
    // 获取登陆后要通知的消息
    async getLoginNotice ({ commit, state, dispatch }, flag) {
      let { data } = await NoticeInteractor.getLoginNotice(flag)
      commit('SET_LOGINNOTICE', data.list)
    },
    // 已读登录通知的消息
    async readNotice ({ commit, state, dispatch }, id) {
      if (state.loginNotices.length) {
        let data = state.loginNotices.map(notice => notice.id != id)
        commit('SET_LOGINNOTICE', data)
      }
      await dispatch('getBadgeCount')
    },
    getCorpList ({ commit, state, dispatch }, param) {
      return new Promise((resolve, reject) => {
        api['user/getCorpList'](param).then(res => {
          var cache = res.data || {}
          var item = cache.responseBeans || []
          resolve({ item,msg:cache.msg })
        }).catch(res => {
          reject(res)
        })
      })
    },
    // 获取home页面菜单栏需要可操作或显示的产品
    async getAuthorizationPnos ({ commit, state, dispatch }) {
      return new Promise(async (resolve, reject) => {
        try {
          let temp = ''
          if(Object.keys(state.userInfo).length) {
            temp = 'common/getAuthorizationPnos'
          } else {
            temp = 'common/getAuthorizationPnosNoLogin'
          }
          const {data} = await api[temp]()
          commit('SET_AUTHORIZATIONPNOSMAP', data)
          resolve(data)
        } catch(error) {
          throw error
          reject(error)
        }
      })
    },
    // 获取home页面导航栏需要可操作或显示的产品
    async queryVipParameternavbar ({ commit, state, dispatch }) {
      return new Promise(async (resolve, reject) => {
        try {
          // console.log(15325363)
          const  message   = await api['common/queryVipParameter']({paramNo:'11605008'}) //消息
          const to_do  = await api['common/queryVipParameter']({paramNo:'11605009'}) //待办
          const  my  = await api['common/queryVipParameter']({paramNo:'11605010'}) //我的
          let  taberr=[]
          if(message.data){
            message.data.value1==1 ? taberr.push('消息') : ''
          }
          if(to_do.data){
            to_do.data.value1==1 ? taberr.push('待办') : ''
          }
          if(my.data){
            my.data.value1==1 ?  taberr.push('A007') : ''
          }
          commit('SET_NAVBAR', taberr)
          resolve(taberr)
        } catch (error) {
          reject(error)
          throw error
        }
      })
    },

    // 获取app内各种列表的数量  用小红点的形式展示
    async getBadgeCount ({ commit, state, dispatch }) {
      let badgeDotCount = {
        message: 0,
        messaged: 0,
        approval: 0,
        approvaled: 0,
        topay: 0,
        daibantotal: 0,
        waitapproval: 0,
      }

      try {
        const { data: approvalData = {} } = await api['approval/vipBpmForMyAppCountNew']({
          approveType: 1,
        })
        const { data: toPayData = {} } = await api['common/totalCount'](ToPayParams)

        badgeDotCount.approval = approvalData.myAppedtotal
        badgeDotCount.topay = toPayData.willPayCount
        badgeDotCount.approvaled = approvalData.myApptotal
        badgeDotCount.waitapproval = toPayData.approvalCount

        badgeDotCount.daibantotal = parseInt(approvalData.myApptotal) + parseInt(approvalData.myAppedtotal) + parseInt(toPayData.willPayCount) + parseInt(toPayData.approvalCount)

        const { data: messageData = {} } = await api['common/findGgtzReadCount']()
        badgeDotCount.message = messageData.unreadCount || 0
        badgeDotCount.messaged = messageData.readCount || 0

        commit('SET_BADGEDOTCOUNT', badgeDotCount)
      } catch (err) {
        throw err
      }
    },
    //隐藏因公因私
    async getBusiness({ commit, state, dispatch }){
      let business
      let data1= await  getParameter('20036') //隐藏因公因私
      data1.value1==1 ? business=false : business=true
      commit("SET_business",business)
    }

  }
}

export default app
